import Ajv, { ErrorObject } from "ajv";
import { isEqual } from "lodash";
import { useMemo, useState } from "react";

const ajv = new Ajv({ allErrors: true, strict: false });

export const parseValidationErrors = (errors?: ErrorObject[] | null) => {
  if (!errors) {
    return [];
  }
  return errors.map((error) => {
    switch (error.keyword) {
      case "additionalProperties":
        return `Unexpected property '${error.params.additionalProperty}' found.`;
      case "type":
        return `Property '${error.instancePath.slice(1)}' should be of type '${error.params.type}'.`;
      case "required":
        return `Missing required property '${error.params.missingProperty}' on '${error.instancePath.slice(1)}'.`;
      default:
        return `Validation error on property '${error.instancePath.slice(1)}': ${error.message}`;
    }
  });
};

export const useSiteConfigurationValidation = (
  siteConfigurationSchema: object,
) => {
  const [validationErrors, setValidationErrors] = useState<string[]>();
  const [validData, setValidData] = useState<object>();
  const validateSiteConfiguration = useMemo(
    () => ajv.compile(siteConfigurationSchema),
    [siteConfigurationSchema],
  );

  const validate = (data: object) => {
    if (!isEqual(data, validData)) {
      const valid = validateSiteConfiguration(data);
      if (!valid) {
        setValidData(undefined);
        setValidationErrors(
          parseValidationErrors(validateSiteConfiguration.errors),
        );
        return false;
      } else {
        setValidData(data);
        setValidationErrors(undefined);
        return true;
      }
    }
  };

  return { validationErrors, validate };
};
